import React, { useEffect, useState } from "react";

import InputField from "../../../common/InputField";
import * as Yup from "yup";

import { Typography, Box, Grid } from "@mui/material";
import { Formik, Form } from "formik";
import { LinkButton, SecondaryButton } from "../../../common/Buttons";

import "../../../components/components.scss";
import "../../../common/styles/colors.scss";
import "./healthcare-proxy.scss";
import TextCapsule from "../../../common/TextCapsule";
import {
  getHealthcareProxy,
  postHealthcareProxy,
} from "../../../services/documentServices";
import { toast } from "react-hot-toast";
import DeleteIcon from "../../../assets/icons/DeleteIcon.png";
import {
  FormHeading,
  getKeyFromText,
  getUserIdFromLocalStorage,
} from "../../../utils/Utilities";
import { useTranslation } from "react-i18next";
import { Circles } from "react-loader-spinner";
import { t } from "i18next";

const actList = [
  {
    id: 0,
    name: "solely represent",
  },
  {
    id: 1,
    name: "jointly represent",
  },
];
const AttorneyDetails = ({ handleSkip, next, setButtonDisabled }) => {
  const { t } = useTranslation();
  let uID = getUserIdFromLocalStorage();
  const [selectedProperties, setSelectedProperties] = useState(actList[0]);
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [initialValues, setInitialValues] = useState({
    forms: [
      {
        name: "",
        dateOfBirth: "",
        address: "",
        email: "",
        phone: "",
      },
    ],
  });
  async function fetchData() {
    setIsLoading(true);
    try {
      const array = [];
      const result = await getHealthcareProxy(uID);
      if (result?.success && result?.payLoad) {
        setData(result.payLoad);
        if (
          result.payLoad.attorneyDetails !== null &&
          result.payLoad.attorneyDetails?.length
        ) {
          result.payLoad.attorneyDetails.map((elem) => {
            array.push({
              ...elem,
              dateOfBirth: elem.dateOfBirth?.slice(0, 10),
            });
          });

          setInitialValues({ forms: array });
          if (result.payLoad.attorneyDetails.length > 1) {
            setSelectedProperties(actList[1]);
          }
        }
      }
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  }
  useEffect(() => {
    fetchData();
  }, []);
  const validate = Yup.object().shape({
    name: Yup.string().max(50, t("max-50-characters")).nullable(),
    email: Yup.string()
      .matches(
        // eslint-disable-next-line
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        t("Must-be-ValidEmail")
      )
      .nullable(),
    dateOfBirth: Yup.string().nullable(),
    address: Yup.string().max(50, t("max-50-characters")).nullable(),
    phone: Yup.number(t("must-be-number"))
      .min(0, t("must-be-positive"))
      .test(
        "len",
        t("less-than-15"),
        (val) => !val || (val && val.toString().length <= 15)
      )
      .nullable()
      .typeError(t("must-be-number")),
    // phone: Yup.string()
    //   .matches(/^[0-9\/]+$/, t("must-be-number"))
    //   .test(
    //     "len",
    //     t("less-than-15"),
    //     (val) => !val || (val && val.toString().length <= 15)
    //   ),
  });

  const validateArrayOfForms = Yup.object().shape({
    forms: Yup.array().of(validate),
  });
  const handleClickOnList = (elem, formik) => {
    setSelectedProperties(elem);
    if (elem.id === 0) {
      formik.setFieldValue("forms", [formik.values.forms[0]]);
    }
  };
  const handleSubmit = async (values) => {
    setButtonDisabled(true);
    const payload = {
      ...data,
      attorneyDetails: [...values.forms],
    };
    const result = await postHealthcareProxy(payload, uID);
    if (result?.success) {
      // toast.success(
      //   t(
      //     result?.message
      //       .toLowerCase()
      //       .replaceAll(" ", "-")
      //       .replaceAll("/", "-")
      //       .replaceAll(",", "")
      //       .replaceAll("'", "")
      //   )
      // );
      next();
    }
    setButtonDisabled(false);
  };
  const addAttorney = (formik) => {
    formik.setFieldValue("forms", [
      ...formik.values.forms,
      {
        name: "",
        dateOfBirth: new Date().toISOString().slice(0, 10),
        address: "",
        email: "",
        phone: "",
      },
    ]);
  };
  const handleDelete = (index, formik) => {
    setInitialValues({
      forms: [
        ...initialValues.forms.filter((_, eleIndex) => eleIndex !== index),
      ],
    });
    formik.setFieldValue("forms", [
      ...formik.values.forms.filter((_, eleIndex) => eleIndex !== index),
    ]);
  };
  const handleDateOfBirthKeyDown = (event) => {
    event.preventDefault();
  };
  return (
    <div className="attorney-details-container summary-table documents-card-height">
      {isLoading ? (
        <Box component="div" className="loader-container">
          <Circles color="#dfc8db" height={80} width={80} />
        </Box>
      ) : (
        <Box component="div" width="60%">
          <FormHeading variant="h4" color="color.magentaDark1">
            {t("attorney-detail")}
          </FormHeading>
          <Typography variant="p" color="color.magentaDark1">
            {t("a-detail-text")}
          </Typography>
          <Formik
            initialValues={initialValues}
            enableReinitialize={true}
            validationSchema={validateArrayOfForms}
            onSubmit={(values) => {
              // const { phone, ...rest } = values["forms"][0];
              // let payload = {
              //   forms: [{ phone: phone.replace(/\//g, ""), ...rest }],
              // };
              // handleSubmit(payload);
              handleSubmit(values);
            }}
          >
            {(formik) => {
              return (
                <>
                  {formik.values.forms.map((item, index) => {
                    return (
                      <Box
                        component="form"
                        id="form_submit"
                        onSubmit={formik.handleSubmit}
                        marginTop="1rem"
                        position="relative"
                      >
                        {index !== 0 && (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                              cursor: "pointer",
                            }}
                          >
                            <img
                              src={DeleteIcon}
                              onClick={() => {
                                handleDelete(index, formik);
                              }}
                            />
                          </div>
                        )}
                        <InputField
                          fullWidth
                          variant="standard"
                          label={t("input-5")}
                          name={`forms[${index}].name`}
                          type="text"
                          value={formik.values.forms[index].name}
                        />
                        <InputField
                          InputLabelProps={{ shrink: true }}
                          fullWidth
                          variant="standard"
                          label={t("input-2")}
                          name={`forms[${index}].dateOfBirth`}
                          // name="date"

                          type="date"
                          onKeyDown={handleDateOfBirthKeyDown}
                          value={formik.values.date}
                          onChange={(newValue) => {
                            formik.setFieldValue("dateOfBirth", newValue);
                          }}
                        // =                          onFocus={(e) => (e.target.type = "date")}
                        />
                        <InputField
                          fullWidth
                          variant="standard"
                          label={t("input-12")}
                          name={`forms[${index}].address`}
                          type="text"
                        />
                        <InputField
                          fullWidth
                          variant="standard"
                          label={t("input-3")}
                          name={`forms[${index}].email`}
                          type="email"
                        />

                        <InputField
                          fullWidth
                          variant="standard"
                          label={t("input-4")}
                          name={`forms[${index}].phone`}
                          type="string"
                          InputLabelProps={{ shrink: true }}
                        />
                        {index === 0 && (
                          <>
                            <Box component="div" className="act-section">
                              <Typography varient="p">
                                {t("a-detail-text-2")}
                              </Typography>
                              <Box component="div" className="act-sub-section">
                                {actList.map((elem) => {
                                  return (
                                    <TextCapsule
                                      key={elem.id}
                                      title={t(getKeyFromText(elem.name))}
                                      click={() =>
                                        handleClickOnList(elem, formik)
                                      }
                                      width="50%"
                                      minWidth="auto"
                                      padding="10px 0px"
                                      textAlign="center"
                                      fontSize="14px"
                                      bgColor={
                                        selectedProperties.id === elem.id
                                          ? "color.magentaLight2"
                                          : "color.lightGrey"
                                      }
                                      color={
                                        selectedProperties.id === elem.id
                                          ? "color.black"
                                          : "color.dimGrey"
                                      }
                                    />
                                  );
                                })}
                              </Box>
                            </Box>
                          </>
                        )}
                      </Box>
                    );
                  })}
                  {/* {selectedProperties.id === 1 && ( */}
                  <Typography sx={{ mt: 2, display: "flex" }}>
                    <SecondaryButton
                      title={
                        <>
                          <Typography
                            sx={{
                              fontWeight: 900,
                              fontSize: "1.5rem",
                              marginRight: "0.5rem",
                              // position: "absolute",
                              // top: "-6%",
                              // left: "13%",
                            }}
                          >
                            +
                          </Typography>{" "}
                          {t("a-detail-add-new-attorney")}
                        </>
                      }
                      textTransform="initial"
                      fontWeight="normal"
                      bgColor="#DEDEDE"
                      borderRadius="40px"
                      padding="2px auto"
                      width="auto"
                      border="none"
                      color="color.black"
                      hoverBgColor="#DEDEDE"
                      click={() => {
                        addAttorney(formik);
                      }}
                    />
                  </Typography>
                  {/* // )} */}

                  <Box component="div" className="act-section">
                    <Box component="div" textAlign="justify">
                      {t("a-detail-para")}
                    </Box>
                  </Box>
                </>
              );
            }}
          </Formik>
        </Box>
      )}
    </div>
  );
};

export default AttorneyDetails;
